import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Notifications, {notify} from 'react-notify-toast';
import Obfuscate from 'react-obfuscate'

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const Login = () =>
  <div>
    <LoginForm/>
  </div>


@inject('userStore')
@withRouter
@observer
class LoginForm extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
        email: '',
        password: '',
        error: null,
        forgottenPassword:false
      };
	}

  	onSubmit = (event) => {
    	event.preventDefault();

    	const { email, password, forgottenPassword} = this.state;

    	const { history,} = this.props;
      if (!forgottenPassword){
        this.props.userStore.get_token(email, password).then((res) => {
          if (res.response && res.response.status === 401){
              notify.show("Incorrect Username/Password", "error", 4000);
          }
        });
      } else {
        // reset password
        this.props.userStore.resetPassword(email).then((res) => {
          if (res.data.errors === 0){
            notify.show(res.data.message, "success", 3000);
            this.setState({forgottenPassword:!forgottenPassword});
          } else {
            notify.show(res.data.message, "error", 3000);
          }
        });
      }
  	}

  render() {
	  const {
      email,
      password,
      error,
      forgottenPassword
    } = this.state;

    const isInvalid = email === '';
    return (
      <React.Fragment>
  	    <div className="row min-h-fullscreen center-vh p-20 m-0">
        <Notifications/>
  	      <div className="col-12">
  	        <div className="card card-shadowed px-50 py-30 w-400px mx-auto" style={{maxWidth: 100 + '%'}}>
  	          <img src={require('../img/logo_se_full.png')} style={{marginBottom:20 + 'px'}}/>
  	          <br/>
  	          { error && <p>{error.message}</p> }
  	          <form className={this.state.email !== '' ? "form-type-material do-float" : "form-type-material"} onSubmit={this.onSubmit}>
  				      <div className="form-group m-form__group">
  	              <input type="text" className="form-control"
  	              	value={email}
            			onChange={event => this.setState(byPropKey('email', event.target.value))}/>
  	              <label>{'Email'}</label>
  	            </div>
                {!forgottenPassword ?
                <React.Fragment>
                  <div className="form-group">
    	              <input type="password" className="form-control"
    	              	value={password}
              			onChange={event => this.setState(byPropKey('password', event.target.value))}/>
    	              <label>{'Password'}</label>
    	            </div>
    	            <div className="form-group flexbox flex-column flex-md-row">
    	              <a className="cursor-pointer text-muted hover-primary fs-13 mt-2 mt-md-0" onClick={()=>this.setState({forgottenPassword:!forgottenPassword})}>{'Forgot password?'}</a>
    	            </div>
                </React.Fragment>
                :
                <React.Fragment>
                <p className="small">Your password will be reset and sent in an email.</p>
                  <div className="flexbox flex-column flex-md-row">
                    <p>
                      Know your password? <a className="cursor-pointer text-muted hover-primary fs-13 mt-2 mt-md-0" onClick={()=>this.setState({forgottenPassword:!forgottenPassword})}>{'Sign In!'}</a>
                    </p>
                  </div>
                </React.Fragment>
                }
  	            <div className="form-group">
  	              <button disabled={isInvalid} type="submit" className="btn btn-bold btn-block btn-primary">{!forgottenPassword ? 'Log In' : 'Reset Password'}</button>
  	            </div>
  	          </form>
  	        </div>
  	        <p className="text-center text-muted fs-13 mt-20">{'Interested in an account? '}
            <Obfuscate
              email="andrew@angstromsys.com"
              headers={{
                subject: 'SimplyEngaging.com - Account Inquiry'
              }}>
              {'Contact Us'}
            </Obfuscate>
            </p>
  	      </div>
  	      <footer className="col-12 align-self-end text-center fs-13">
  	        <p className="mb-0"><small>{'Copyright © 2019 '}<a href="https://simplyengaging.com">Simply Engaging Technologies, LLC</a>{'. All rights reserved.'}</small></p>
  	      </footer>
  	    </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Login);

export {
  LoginForm,
};



// WEBPACK FOOTER //
// ./src/components/Login.js